import styled from 'styled-components'
import { breakpoints, colors } from 'style'

export const YourBookCardsContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${colors.white};
  .container {
    padding-top: 58px;
    padding-bottom: 58px;
    h1 {
      margin-bottom: 58px;
      text-align: center;
    }
  }
  @media (max-width: ${breakpoints.sm}px) {
    .container {
      h1 {
        margin-bottom: 18px;
        text-align: left;
      }
    }
  }
  @media (max-width: 413px), (max-height: 845px) {
  }
`
